(function (window, document) {
  'use strict';

  function iceCarouselOwnsHero() {
    var root = document.getElementById('home-slideshow-owl');
    return !!(root && root.getAttribute('data-ice-carousel-ready') === 'true');
  }

  if (window.jQuery && window.jQuery.fn && typeof window.jQuery.fn.owlCarousel === 'function') {
    var originalOwlCarousel = window.jQuery.fn.owlCarousel;

    if (!originalOwlCarousel.__iceHeroGuard) {
      var guardedOwlCarousel = function () {
        if (iceCarouselOwnsHero() && this.filter && this.filter('#home-slideshow-owl').length) {
          return this;
        }
        return originalOwlCarousel.apply(this, arguments);
      };

      guardedOwlCarousel.__iceHeroGuard = true;
      window.jQuery.fn.owlCarousel = guardedOwlCarousel;
    }
  }

  if (typeof window.Swiper === 'function' && !window.Swiper.__iceHeroGuard) {
    var OriginalSwiper = window.Swiper;

    var GuardedSwiper = function (selector, options) {
      if (iceCarouselOwnsHero() && selector === '.swiper-container') {
        return { destroy: function () {} };
      }
      return new OriginalSwiper(selector, options);
    };

    GuardedSwiper.prototype = OriginalSwiper.prototype;
    GuardedSwiper.__iceHeroGuard = true;
    window.Swiper = GuardedSwiper;
  }
}(window, document));
